"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const automotive_axios_extensions_1 = require("@inchcape/automotive-axios-extensions");
const axiosConfigValues_1 = require("./axiosConfigValues");
exports.defaultAxiosInstance = axios_1.default.create({
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    timeout: axiosConfigValues_1.axiosConfigValues.timeoutPeriod,
    adapter: automotive_axios_extensions_1.axiosCachingAdapter(axiosConfigValues_1.axiosConfigValues.cacheMaxAge),
});
const setCookieConfig = {
    cookieName: axiosConfigValues_1.axiosConfigValues.sessionCookieName,
    cookieDomain: axiosConfigValues_1.axiosConfigValues.sessionDomain,
    cookieLifetime: axiosConfigValues_1.axiosConfigValues.sessionLifetime,
    requestHeaderName: axiosConfigValues_1.axiosConfigValues.sessionRequestHeaderName,
    responseHeaderName: axiosConfigValues_1.axiosConfigValues.sessionResponseHeaderName
};
automotive_axios_extensions_1.axiosSetCookieInterceptor(exports.defaultAxiosInstance, setCookieConfig);
exports.default = exports.defaultAxiosInstance;
//# sourceMappingURL=axiosConfig.js.map